import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import MundialUserDetailsModal from './MundialUserDetailsModal';
import NagusiBackNav from '../common/NagusiBackNav';
export default class MundialClassificationPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "loadingMore", false);
    _defineProperty(this, "ranking", []);
    // Pagination state
    _defineProperty(this, "offset", 0);
    _defineProperty(this, "limit", 50);
    _defineProperty(this, "hasMore", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.offset = 0;

    // Fetch teams so the details modal can resolve team names by ID from the store cache
    const pTeams = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-teams'
    });
    const pClassification = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-classification',
      params: {
        page: {
          limit: this.limit,
          offset: this.offset
        }
      }
    });
    Promise.all([pTeams, pClassification]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        teamsResp = _ref2[0],
        classResp = _ref2[1];
      app.store.pushPayload(teamsResp); // Push to cache
      this.ranking = app.store.pushPayload(classResp) || [];
      const meta = classResp.meta || {};
      const totalCount = meta.totalCount || 0;
      this.hasMore = this.ranking.length < totalCount;
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  loadMore() {
    if (this.loadingMore || !this.hasMore) return;
    this.loadingMore = true;
    this.offset += this.limit;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-classification',
      params: {
        page: {
          limit: this.limit,
          offset: this.offset
        }
      }
    }).then(response => {
      const nextResults = app.store.pushPayload(response) || [];
      this.ranking = [...this.ranking, ...nextResults];
      const meta = response.meta || {};
      const totalCount = meta.totalCount || 0;
      this.hasMore = this.ranking.length < totalCount;
      this.loadingMore = false;
      m.redraw();
    }).catch(() => {
      this.loadingMore = false;
      m.redraw();
    });
  }
  showUserDetails(entry) {
    app.modal.show(MundialUserDetailsModal, {
      entry
    });
  }
  scrollToUser(userId) {
    let el = document.getElementById("mundial-user-row-".concat(userId));
    if (!el) {
      el = document.getElementById("mundial-podium-user-".concat(userId));
    }
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      el.classList.remove('is-flashing');
      void el.offsetWidth;
      el.classList.add('is-flashing');
      setTimeout(() => {
        if (el) el.classList.remove('is-flashing');
      }, 2600);
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const ranks = [];
    const ties = [];
    let currentRank = 1;
    for (let i = 0; i < this.ranking.length; i++) {
      if (i > 0 && this.ranking[i].score() !== this.ranking[i - 1].score()) {
        currentRank = i + 1;
      }
      ranks[i] = currentRank;
    }
    for (let i = 0; i < this.ranking.length; i++) {
      const r = ranks[i];
      ties[i] = ranks.filter(x => x === r).length > 1;
    }
    const top3 = this.ranking.slice(0, 3);
    const restOfPlayers = this.ranking; // Display all in the main table too for clarity

    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Mundial 2026"
    }), m("h2", {
      className: "BolillaPage-Title"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.porrita_title')), m("div", {
      className: "JokoakSubmenu",
      style: "display: flex; gap: 15px; margin-bottom: 25px; justify-content: center; background: #fff; padding: 10px; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); border: 1px solid rgba(0,0,0,0.06);"
    }, m(Link, {
      href: "/mundial-2026/clasificacion",
      className: "JokoakSubmenu-link active",
      style: "padding: 8px 20px; border-radius: 20px; font-weight: bold; font-size: 13px; text-decoration: none; color: #fff; background: #EE2523; transition: all 0.2s;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.classification_tab')), m(Link, {
      href: "/mundial-2026/selecciones",
      className: "JokoakSubmenu-link",
      style: "padding: 8px 20px; border-radius: 20px; font-weight: bold; font-size: 13px; text-decoration: none; color: #666; background: transparent; transition: all 0.2s;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.teams_tab'))), m("div", {
      style: "background: #fff; padding: 25px; border-radius: 16px; box-shadow: 0 4px 15px rgba(0,0,0,0.05); border: 1px solid #eee; margin-bottom: 25px; line-height: 1.6;"
    }, m("h4", {
      style: "font-weight: bold; margin: 0 0 10px 0;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.points_rules_title')), m("div", {
      style: "color: #666; font-size: 13px;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.points_rules_intro'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_groups'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_phases'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_champion'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_runnerup'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_third_fourth'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_top_scorer'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_mvp'), m("br", null), m("br", null), m("strong", {
      style: "color: #EE2523;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.deadline_text')))), this.ranking.length === 0 ? m("div", {
      style: "text-align: center; padding: 40px; background: #fff; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 20px rgba(0,0,0,0.04);"
    }, m("span", {
      style: "font-size: 3em;"
    }, "\uD83C\uDFC6"), m("h3", {
      style: "font-weight: 800; margin-top: 15px;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.no_predictions')), m("p", {
      style: "color: #666; margin-bottom: 20px;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.be_first_to_predict')), m(Link, {
      href: "/mundial-2026/pronosticar",
      className: "Button Button--primary",
      style: "border-radius: 20px; font-weight: bold; padding: 8px 24px;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.make_prediction_button'))) : m("div", null, top3.length > 0 && m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Podium"
    }, top3[1] && this.renderPodiumUser(top3[1], ranks[1]), top3[0] && this.renderPodiumUser(top3[0], ranks[0]), top3[2] && this.renderPodiumUser(top3[2], ranks[2]))), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Season-Statistics",
      style: "width: 100%;"
    }, m("div", {
      className: "Top-Players-Full-Table",
      style: "background: #fff; padding: 20px; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 20px rgba(0,0,0,0.04);"
    }, m("div", {
      className: "Classification-Header-Actions"
    }, m("h4", {
      style: "font-weight: 800; font-size: 1.25em; margin: 0;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.leaderboard_title')), (() => {
      const currentUserId = app.session.user ? app.session.user.id() : null;
      if (!currentUserId) return null;
      const userRankIndex = this.ranking.findIndex(entry => entry.user() && String(entry.user().id()) === String(currentUserId));
      if (userRankIndex === -1) return null;
      const myRank = ranks[userRankIndex];
      return m(Button, {
        className: "Button Button--my-position",
        onclick: () => this.scrollToUser(currentUserId),
        icon: "fas fa-crosshairs"
      }, m("span", null, "Mi posici\xF3n (", myRank, "\xBA)"));
    })()), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, app.translator.trans('nagusi-match-ratings.forum.mundial.user_header')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.points_header')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.details_header')))), m("tbody", null, this.ranking.map((entry, index) => {
      const user = entry.user();
      if (!user) return null;
      const isCurrent = app.session.user && String(app.session.user.id()) === String(user.id());
      const userUrl = app.route('user', {
        username: user.slug()
      });
      const rank = ranks[index];
      return m("tr", {
        key: user.id(),
        id: "mundial-user-row-".concat(user.id()),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info",
        style: "display: flex; align-items: center; gap: 10px;"
      }, m("span", {
        className: "rank-badge-cell"
      }, m("span", {
        className: "rank-badge rank-".concat(rank)
      }, rank, "\xBA")), m(Link, {
        href: userUrl
      }, avatar(user, {
        className: 'Player-Avatar-Tiny'
      })), m(Link, {
        href: userUrl,
        className: "Player-Name",
        style: "font-weight: bold; text-decoration: none; color: #333;"
      }, username(user)), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"), entry.sameVoteCount() > 1 && m("span", {
        title: app.translator.trans('nagusi-match-ratings.forum.mundial.shared_vote_tooltip', {
          count: entry.sameVoteCount()
        }),
        style: "font-size: 11px; color: #777; background: #f0f0f0; padding: 2px 6px; border-radius: 10px; display: inline-flex; align-items: center; gap: 4px; font-weight: normal; margin-left: 5px;"
      }, m("i", {
        className: "fas fa-users",
        style: "font-size: 10px; color: #888;"
      }), " ", entry.sameVoteCount()))), m("td", {
        className: "center bold",
        style: "font-size: 1.15em; color: #EE2523;"
      }, entry.score()), m("td", {
        className: "center"
      }, m(Button, {
        className: "Button Button--link",
        onclick: () => this.showUserDetails(entry),
        icon: "fas fa-info-circle"
      }, m("span", {
        className: "Button-label"
      }, app.translator.trans('nagusi-match-ratings.forum.mundial.view_choices')))));
    })))), this.hasMore && m("div", {
      style: "text-align: center; margin-top: 20px;"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.loadingMore,
      onclick: () => this.loadMore(),
      style: "border-radius: 20px; padding: 8px 24px; font-weight: bold;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.load_more_participants')))))))));
  }
  renderPodiumUser(entry, position) {
    const user = entry.user();
    if (!user) return null;
    const isFirst = position === 1;
    const isCurrent = app.session.user && String(app.session.user.id()) === String(user.id());
    const userUrl = app.route('user', {
      username: user.slug()
    });
    const pathId = 'txapela-podium-path-' + Math.random().toString(36).substr(2, 9);
    return m("div", {
      id: "mundial-podium-user-".concat(user.id()),
      className: "Podium-Player pos-".concat(position, " ").concat(isFirst ? 'MVP' : '', " ").concat(isCurrent ? 'highlight-current-user' : '')
    }, m(Link, {
      href: userUrl,
      className: "Player-Avatar-Wrapper"
    }, avatar(user), m("div", {
      className: "Rank-Badge"
    }, position), isFirst && m("div", {
      className: "MVP-Txapela"
    }, m("svg", {
      viewBox: "0 0 100 45",
      className: "txapela-svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, m("defs", null, m("path", {
      id: pathId,
      d: "M 8,24 Q 50,13 92,24",
      fill: "none",
      stroke: "none"
    })), m("ellipse", {
      cx: "50",
      cy: "30",
      rx: "35",
      ry: "8",
      fill: "rgba(0, 0, 0, 0.25)"
    }), m("path", {
      d: "M 8,24 C 8,6 92,6 92,24 C 92,36 8,36 8,24 Z",
      fill: "#EE2523"
    }), m("path", {
      d: "M 20,28 Q 50,34 80,28 Q 50,23 20,28 Z",
      fill: "#131314"
    }), m("path", {
      d: "M 50,11 Q 50,4 51,2 Q 53,4 53,11 Z",
      fill: "#EE2523"
    }), m("text", {
      fill: "#ffffff",
      "font-size": "4.5",
      "font-weight": "900",
      "letter-spacing": "0.7",
      stroke: "#EE2523",
      "stroke-width": "0.1px",
      dy: "1.5",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, m("textPath", {
      href: "#".concat(pathId),
      startOffset: "50%",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, "MUNDIAL 2026"))))), m("div", {
      className: "Player-Details"
    }, m(Link, {
      href: userUrl,
      className: "Player-Name"
    }, username(user), isCurrent && m("span", {
      className: "badge-you"
    }, "T\xDA")), m("div", {
      className: "Player-Score-Container"
    }, m("span", {
      className: "Player-Average"
    }, entry.score()), m("span", {
      className: "Label"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.points_label')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/mundial/MundialClassificationPage', MundialClassificationPage);